import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Actions from '../../../actions'
import $t from '../../../i18n'
import { routes } from '../../../consts'
import PageCard from '../PageCard'

import './Wizard.css'

export const Wizard = ({ pages }) => {
  const dispatch = useDispatch()
  const { selectedMember } = useSelector(state => state.account)
  const isAfterConcent = useSelector(state => state.getCare.isAfterConcent)

  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [currentPageProps, setCurrentPageProps] = useState({})

  const navigateHome = () => {
    dispatch(Actions.createAction(Actions.NAVIGATED_TO, routes.ROOT))
  }

  const currentPage = pages?.[currentPageIndex]

  const getPage = (page, i) => {
    return page?.component
      ? React.createElement(page?.component, {
          onNext: props => onNext(i, props),
          ...currentPageProps,
        })
      : null
  }

  const onNext = (index, props) => {
    if (index < pages?.length - 1) {
      setCurrentPageIndex(index + 1)
      setCurrentPageProps(props)
    } else {
      dispatch(Actions.createAction(Actions.WIZARD_ENDED))
    }
  }

  const onPrev = (index, props) => {
    index > 0 ? setCurrentPageIndex(index - 1) : navigateHome()
    setCurrentPageProps(props)
  }

  const getProgress = () => {
    const stepWidth = `calc(100% / ${pages?.length})`
    return (
      <div className="wizard-header">
        {selectedMember?.firstName && (
          <div className="member-detals">
            {$t('homeScreen.familyFillingData')}{' '}
            <span className="bold">{selectedMember?.firstName}</span>
          </div>
        )}
        <div className="wizard-progress">
          <div
            className="wizard-filled-steps"
            style={{ width: `calc(${currentPageIndex + 1} * ${stepWidth})` }}
          />
          <div className="wizard-steps">
            {pages?.map((step, i) => {
              return (
                <div
                  key={i}
                  className="wizard-step"
                  style={{
                    width: stepWidth,
                  }}
                />
              )
            })}
          </div>
        </div>
      </div>
    )
  }

  return (
    <PageCard
      className="wizard-page"
      headerComponent={getProgress()}
      enableBack={
        currentPageIndex !== 0 && !currentPage?.disableBack && !isAfterConcent
      }
      onBack={() => onPrev(currentPageIndex)}
      enableSkip={!!currentPage?.displaySkip}
      onSkip={() => onNext(currentPageIndex)}
    >
      {getPage(currentPage, currentPageIndex)}
    </PageCard>
  )
}

export default Wizard
